import { FieldType } from 'module/types/filter-field/field/field';
import { dueDateKeyCreator } from './due-date';
import { singleSelectKeyCreator } from './single-select';
import { startDateKeyCreator } from './start-date';
import { GetKeyCreatorFunction } from './types';

export const getKeyCreator: GetKeyCreatorFunction = (field) => {
  switch (field.type) {
    case FieldType.Date:
      switch (field.fieldName) {
        case 'startDate':
          return startDateKeyCreator;
        case 'dueDate':
          return dueDateKeyCreator;
        default:
          return undefined;
      }
    case FieldType.SingleUser:
    case FieldType.SingleSelect:
      switch (field.fieldName) {
        default:
          return singleSelectKeyCreator;
      }
    case FieldType.Assignee:
    case FieldType.Text:
    case FieldType.Number:
    case FieldType.MultiSelect:
    case FieldType.MultiUser:
    case FieldType.Estimate:
    case FieldType.Boolean:
    default:
      return undefined;
  }
};
